class GallerySlider {
  constructor() {
    this.settings = {
      slider: '.js-gallery-slider',
    };
  }

  init() {
    const $element = $(this.settings.slider);
    if (!$element.length) {
      return;
    }
    import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
      $element.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        speed: 300,
        adaptiveHeight: true,
      });
    });
  }
}

export default GallerySlider;
